import { useEffect, useState } from "react";

export const PALISIS_URL = "https://coolrunnings-capetown.palisis.com/";

export const palisisShop = (product, base) => `${base || PALISIS_URL}?book-direct=${product}`;
export const SITE_URL = "https://coolrunnings.capetown";
export const YOUTUBE_ID = "XyjlNhXV6MQ";
// In-page play is ready but the video's owner currently has embedding switched off on YouTube.
// Set to true after ticking "Allow embedding" in YouTube Studio — the film will then play in-page automatically.
export const FILM_EMBED_ENABLED = false; // YouTube owner still has "Allow embedding" OFF — the play button on the poster attempts in-page play on click and falls back gracefully
export const PHONE = "+27 21 949 4439";
export const PHONE_HREF = "tel:+27219494439";
export const EMAIL = "ops@coolrunnings.capetown";
export const BOOKINGS_EMAIL = "janet@coolrunnings.capetown";
export const ADDRESS = "Off Carl Cronje Drive, Tygervalley, Cape Town, 7530";
export const MAPS_COORDS = "-33.8802328,18.629964";
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${MAPS_COORDS}`;

export const KIOSK_MENU = [
  {
    category: "Hot Food",
    items: [
      { name: "Crispy Pizza*", detail: "Ask about our options", price: "R170" },
      { name: "Jumbo Beef Frankfurter", detail: "XXL hot dog with a fresh roll", price: "R79" },
      { name: "Tasty Cheesegriller", detail: "With a fresh roll", price: "R69" },
      { name: "Traditional German Bratwurst", detail: "With a fresh roll", price: "R69" },
      { name: "Juicy Boerewors*", detail: "With a fresh roll", price: "R79" },
      { name: "Gourmet French Fries*", detail: "Small / large", price: "R45 / R55" },
      { name: "Chicken Burger*", detail: "With lettuce", price: "R170" },
      { name: "Beef Burger", detail: "With gherkin, tomato and lettuce", price: "R170" },
      { name: "Cheese Burger*", detail: "With gherkin, tomato and lettuce", price: "R175" },
      { name: "Add Fries*", detail: "To any of the above", price: "R35" },
      { name: "Add Cheese", detail: "To any of the above", price: "R5" },
    ],
  },
  {
    category: "Snacks",
    items: [
      { name: "Droewors Sticks / Biltong Packs / Mixed Nuts", price: "R35 – R45" },
      { name: "Lays / Simba Chips", price: "R15 – R45" },
      { name: "Lollipops & Sweets", detail: "Wine Gums, Liquorish, Jelly Babies etc", price: "R2 – R45" },
      { name: "Chocolates", detail: "Lunch Bar, Bar-One, Kit Kat etc", price: "R19 – R40" },
      { name: "Ola Ice Cream", detail: "Magnum, Cornetto etc", price: "R20 – R50" },
    ],
  },
  {
    category: "Hot Drinks",
    items: [
      { name: "Tea", detail: "Ceylon or Rooibos", price: "R30" },
      { name: "Coffee", price: "R40" },
      { name: "Espresso", price: "R32 / R35" },
      { name: "Café Latte", price: "R40" },
      { name: "Cappuccino", price: "R40" },
      { name: "Hot or Cold Chocolate", price: "R45" },
    ],
  },
  {
    category: "Cold Drinks",
    items: [
      { name: "Water", detail: "Still or sparkling", price: "R30" },
      { name: "Sodas", detail: "Coke, Coke Zero, Fanta, Cream Soda, Sprite", price: "R28 – R35" },
      { name: "Slush Puppies", detail: "Cherry, blueberry, grape, cream soda", price: "R30 / R40" },
      { name: "Juice", detail: "Juice box / can", price: "R17 / R25" },
      { name: "Energy Drinks", detail: "Powerade, Monster, Red Bull", price: "R28 – R40" },
    ],
  },
];
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/Cool+Runnings+Toboggan+Park+Cape+Town+reviews";
export const TRIPADVISOR_URL =
  "https://www.tripadvisor.co.za/Search?q=Cool%20Runnings%20Cape%20Town";

// South African public holidays (incl. observed Mondays when they fall on a Sunday)
export const SA_PUBLIC_HOLIDAYS = {
  "2026-01-01": "New Year's Day",
  "2026-03-21": "Human Rights Day",
  "2026-04-03": "Good Friday",
  "2026-04-06": "Family Day",
  "2026-04-27": "Freedom Day",
  "2026-05-01": "Workers' Day",
  "2026-06-16": "Youth Day",
  "2026-08-09": "National Women's Day",
  "2026-08-10": "Women's Day observed",
  "2026-09-24": "Heritage Day",
  "2026-12-16": "Day of Reconciliation",
  "2026-12-25": "Christmas Day",
  "2026-12-26": "Day of Goodwill",
  "2027-01-01": "New Year's Day",
  "2027-03-21": "Human Rights Day",
  "2027-03-22": "Human Rights Day observed",
  "2027-03-26": "Good Friday",
  "2027-03-29": "Family Day",
  "2027-04-27": "Freedom Day",
  "2027-05-01": "Workers' Day",
  "2027-06-16": "Youth Day",
  "2027-08-09": "National Women's Day",
  "2027-09-24": "Heritage Day",
  "2027-12-16": "Day of Reconciliation",
  "2027-12-25": "Christmas Day",
  "2027-12-26": "Day of Goodwill",
};
export const QR_IMAGE_URL =
  "https://api.qrserver.com/v1/create-qr-code/?size=260x260&bgcolor=FFFFFF&data=" +
  encodeURIComponent(SITE_URL + "/prices/");

export const HOURS = {
  mon_fri: "11h00 – 18h00",
  sat_sun: "09h00 – 18h00",
};

// the park's opening times, editable by staff in the admin portal —
// the Times page schedule, the robot widget and the open/closed robot all read these
export const DEFAULT_HOURS = {
  weekday_open: "11h00",
  weekday_close: "18h00",
  weekend_open: "09h00",
  weekend_close: "18h00",
};

let hoursCache = null;

export function useLiveHours() {
  const [hours, setHours] = useState(hoursCache || DEFAULT_HOURS);
  useEffect(() => {
    if (hoursCache) return;
    let alive = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/hours`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive && d && d.weekday_open) {
          hoursCache = d;
          setHours(d);
        }
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return hours;
}

export const FARES = [
  {
    id: "single",
    name: "Single Rider",
    rides: "1 ride",
    childPrice: "R110",
    adultPrice: "R120",
    note: "Pay per person, per ride",
    shop: "r-5120",
  },
  {
    id: "three",
    name: "Three Rider Ticket",
    rides: "3 rides",
    childPrice: "R300",
    adultPrice: "R330",
    note: "Shareable between riders",
    shop: "r-5121",
  },
  {
    id: "six",
    name: "Six Rider Ticket",
    rides: "6 rides",
    childPrice: "R500",
    adultPrice: "R560",
    note: "Rides can always be shared",
    shop: "r-5122",
  },
  {
    id: "nappy",
    name: "Happy Nappy Combo",
    rides: "3 adult & 3 kids rides",
    price: "R390",
    perRide: "R65 a ride",
    note: "Valid for 1 adult (15+) with 1 child (3–7) only",
    shop: "r-5125",
  },
  {
    id: "family",
    name: "Happy Family Combo",
    rides: "12 rides, any age",
    price: "R960",
    note: "Rides can always be shared — our bestseller",
    shop: "r-5117",
  },
  {
    id: "day",
    name: "Day Pass",
    rides: "Unlimited rides",
    price: "R790",
    note: "Non-transferable — ride all day long",
    shop: "r-5118",
  },
  {
    id: "workday",
    name: "Working Day Pass",
    rides: "Unlimited, Mon–Fri",
    price: "R600",
    note: "Weekdays excluding public & school holidays",
    shop: "r-5119",
  },
  {
    id: "fast",
    name: "Fast Day Pass",
    rides: "Unlimited + fast lane",
    price: "R1500",
    note: "Skip the regular queue all day with fast lane access",
    shop: "r-5118",
  },
];

export const PLATTERS = [
  {
    id: "chicken-platter",
    name: "Butcher's Board",
    price: "R850",
    desc: "Chicken drumsticks, meatballs and garnish",
    img: "/products/platter-chicken.jpg",
    url: SITE_URL + "/product/chicken-platter/",
    halaal: true,
  },
  {
    id: "savoury-platter",
    name: "Savoury Bites",
    price: "R850",
    desc: "A variety of savouries — pies, samoosas, sausage rolls, half moons, chilli bites and pizza",
    img: "/products/platter-savoury.jpg",
    url: SITE_URL + "/product/savoury-platter/",
    halaal: true,
  },
  {
    id: "sandwich-platter",
    name: "Sandwich Platter",
    price: "R700",
    desc: "Chicken, cold meats, cheese, egg, tuna and garnish on fresh rolls or breads",
    img: "/products/platter-sandwich.jpg",
    url: SITE_URL + "/product/sandwich-platter/",
    halaal: true,
  },
  {
    id: "fruit-platter",
    name: "Healthy Fruit Platter",
    price: "R650",
    desc: "The season's freshest fruits, beautifully arranged",
    img: "/products/platter-fruit.jpg",
    url: SITE_URL + "/product/fruit-platter/",
    halaal: false,
  },
  {
    id: "muffin-platter",
    name: "Mega Muffin Platter",
    price: "R600",
    desc: "Freshly baked muffins & scones, served with butter, jam and cheese",
    img: "/products/platter-muffin.jpg",
    url: SITE_URL + "/product/muffin-platter/",
    halaal: false,
  },
];

export const PARTY_PACKS = [
  {
    id: "nibble-pack",
    name: "Nibble Pack",
    price: "R60",
    url: SITE_URL + "/product/nibble-pack/",
    desc: ["Juice Box", "Flings", "Jelly Tots or similar", "PS or similar", "Lolly Pop"],
    bookingOnly: true,
    img: "/products/pack-nibble-pack.jpg",
  },
  {
    id: "happy-bismillah",
    name: "Happy Bismillah",
    price: "R90",
    url: SITE_URL + "/product/happy-bismillah/",
    desc: ["Mineral Water or Slush Puppie", "Popcorn", "Nik Naks", "Kit Kat and Smarties", "Lolly Pop", "Nuts & Fruits"],
    bookingOnly: true,
    img: "/products/pack-happy-bismillah.jpg",
  },
  {
    id: "classic-snack-attack",
    name: "Classic Snack Attack",
    price: "R90",
    url: SITE_URL + "/product/classic-snack-attack/",
    desc: ["Cool Drink, Water or Slush Puppie", "Bar One", "Simba or Lays Chips", "Jelly Beans or similar Maynards Sweets", "Smarties"],
    bookingOnly: true,
    img: "/products/pack-classic-snack-attack.jpg",
  },
  {
    id: "funky-kosher-kid",
    name: "Funky Kosher Kid",
    price: "R95",
    url: SITE_URL + "/product/funky-kosher-kid/",
    desc: ["Mineral Water", "Lays Chips", "Kit Kat", "Smarties", "Bar One", "Jelly Tots"],
    bookingOnly: true,
    img: "/products/pack-funky-kosher-kid.jpg",
  },
  {
    id: "yummy-party-pack",
    name: "Yummy Party Pack",
    price: "R95",
    url: SITE_URL + "/product/yummy-party-pack/",
    desc: ["Cool Drink, Water or Slush Puppie", "Chocolate", "Doritos", "Astros", "Fruit Plus", "Supa Beacon"],
    bookingOnly: true,
    img: "/products/pack-yummy-party-pack.jpg",
  },
];

export const EVENT_MODULES = [
  {
    id: "corporate",
    icon: "Building2",
    img: "/park-bar.jpg",
    alt: "The licensed bar and beer garden at Cool Runnings",
    title: "Corporate & Team Building",
    tagline: "A year-end function they'll actually talk about.",
    text: "Treat your team to a fun-filled day at Cool Runnings Cape Town! Enjoy exciting toboggan rides on our 1.25 km track, delicious catering and drinks from our fully licensed bar. Perfect for team outings, staff functions and year-end celebrations!",
    bullets: ["Exciting toboggan rides", "Catering & licensed bar", "Reserved seating for groups", "Exclusive venue hire available", "Free entrance & parking"],
    includes: ["Track marshals on duty", "Platter catering (halaal options on request)", "Licensed bar on site", "Free Wi-Fi and shade"],
    idealFor: "Team builds, year-end functions, client days and sports clubs",
    priceHint: "From R170 a ride · platters from R550 · day passes from R600",
    type: "Corporate & Team Building",
  },
  {
    id: "school",
    icon: "GraduationCap",
    img: "/park-queue.jpg",
    alt: "School group meeting the track crew at Cool Runnings",
    title: "School Outings & Educational Trips",
    tagline: "Where adventure meets learning!",
    text: "Give your learners a memorable day out filled with excitement, outdoor fun and a little physics in action!",
    bullets: ["Free park entry for school groups", "Experience gravity and motion firsthand", "Safe, supervised toboggan rides"],
    includes: ["Supervised riding sessions", "Kiosk meals & party packs", "Free parking for buses"],
    idealFor: "School outings, educational trips, church & youth groups",
    priceHint: "From R110 a learner ride · party packs from R60",
    type: "School Outings & Educational Trips",
  },
  {
    id: "birthday",
    icon: "PartyPopper",
    img: "/party-bucket.jpg",
    alt: "A party pack bucket and slush puppie at a Cool Runnings birthday party",
    title: "Birthday & Bachelor Parties",
    tagline: "Bring the crew — we handle the rest.",
    text: "Celebrate with a little adventure! From kids' birthdays to bachelor and bachelorette parties, Cool Runnings is the perfect place to celebrate! Enjoy exciting toboggan rides, delicious catering options and unforgettable moments with your favourite people.",
    bullets: ["Free entry for all guests", "Exciting toboggan rides for all ages", "Party packs and delicious catering platters", "Reserved tables for your celebration", "Bring your own birthday cake or cupcakes"],
    includes: ["Reserved party table", "Kids party packs from R60", "Birthday cake welcome with a booking", "Free parking for the whole crew"],
    idealFor: "Birthdays (from age 3!), bachelor & bachelorette parties, family days",
    priceHint: "Party packs from R60 · kids feasts from R125 · rides from R110",
    type: "Birthday Parties & Bachelor Parties",
  },
];

export const KIDS_FEASTS = [
  {
    id: "tasty-treat-trio",
    name: "Tasty Treat Trio",
    price: "R125",
    url: SITE_URL + "/product/tasty-treat-trio/",
    desc: ["Tasty Hot Dog", "Small Fries", "Cool Drink, Water or Slush Puppie"],
    img: "/products/feast-tasty-treat-trio.jpg",
  },
  {
    id: "chicky-dippers",
    name: "Chicky Dippers",
    price: "R125",
    url: SITE_URL + "/product/chicky-dippers/",
    desc: ["Crispy Chicken Strips", "Small Fries", "Cool Drink, Water or Slush Puppie"],
    halaal: "Can be ordered as halaal on request",
    img: "/products/feast-chicky-dippers.jpg",
  },
  {
    id: "supreme-feast",
    name: "Supreme Feast",
    price: "R225",
    url: SITE_URL + "/product/supreme-feast/",
    desc: ["Sizzlin' Beef Burger", "Small Fries", "Cool Drink, Water or Slush Puppie"],
    halaal: "Can be ordered as halaal on request",
    img: "/products/feast-supreme-feast.jpg",
  },
];

export const FARE_INFO = {
  single: {
    img: "/products/single-rider.jpg",
    bullets: [
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Max weight limit per sledge: 150kg",
      "We are closed when raining!",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Rider tickets are valid on any day, incl. public & school holidays, and are NON-REFUNDABLE.",
      "Rides do NOT expire until they have been used.",
      "You pay per person, per ride!",
    ],
  },
  three: {
    img: "/products/three-rider.jpg",
    bullets: [
      "Rider tickets can always be shared!",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "You pay per person, per ride!",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Rider tickets are valid on any day, incl. public & school holidays, and are NON-REFUNDABLE.",
      "We are closed when raining! Rides do NOT expire until they have been used.",
    ],
  },
  six: {
    img: "/products/six-rides.jpg",
    bullets: [
      "Rider tickets can always be shared!",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "You pay per person, per ride!",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Rider tickets are valid on any day, incl. public & school holidays, and are NON-REFUNDABLE.",
      "We are closed when raining! Rides do NOT expire until they have been used.",
    ],
  },
  family: {
    img: "/park-party.jpg",
    bullets: [
      "The HAPPY FAMILY COMBO is 12 rides for any age — our bestseller!",
      "Rider tickets can always be shared!",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "You pay per person, per ride!",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Rider tickets are valid on any day, incl. public & school holidays, and are NON-REFUNDABLE.",
      "We are closed when raining! Rides do NOT expire until they have been used.",
    ],
  },
  nappy: {
    img: "/products/nappy-combo.jpg",
    bullets: [
      "The HAPPY NAPPY COMBO is '3 rides for 2' — a warm-up lap for an adult & child together.",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Valid on any day, incl. public & school holidays, and NON-REFUNDABLE.",
      "We are closed when raining! Rides do NOT expire until they have been used.",
    ],
  },
  day: {
    img: "/products/day-pass.jpg",
    bullets: [
      "Day Passes are non-transferable and each person needs their own DAY PASS, regardless of age.",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Day Passes are valid on any day, incl. Public- & School Holidays.",
      "We are closed when raining!",
      "DAY PASSES ARE NON-REFUNDABLE.",
    ],
  },
  workday: {
    img: "/park-launch.jpg",
    bullets: [
      "Working Day Passes are non-transferable and each person needs their own pass, regardless of age.",
      "Valid on weekdays only — not valid on weekends, public & school holidays.",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "We are closed when raining!",
      "WORKING DAY PASSES ARE NON-REFUNDABLE.",
    ],
  },
  fast: {
    img: "/dad-riding.jpg",
    bullets: [
      "Fast Day Passes skip the queue — ride via the fast lane all day long.",
      "Fast Day Passes are non-transferable and each person needs their own pass, regardless of age.",
      "Riders must have a height of 1,35m and be at least 8 years old.",
      "Children aged 3–7 need to be accompanied by an adult aged 15+.",
      "Weight limit per sledge: 150kg",
      "Children below age 3 & pregnant women are unfortunately not allowed to ride.",
      "Valid on any day, incl. Public- & School Holidays.",
      "We are closed when raining! FAST DAY PASSES ARE NON-REFUNDABLE.",
    ],
  },
};

export const GIFT_VOUCHERS = ["R200", "R500", "R750"];
export const GIFT_VOUCHER_URL = palisisShop("r-5947");
export const BIRTHDAY_VOUCHER_URL = palisisShop("r-5963");

export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

// --- SA school calendar & public holidays (2026–2027 as supplied by the park; correct any drifting dates here) ---
export const SCHOOL_HOLIDAYS = [
  // 2026 breaks
  ["2026-03-28", "2026-04-07"], // Term 1 break (autumn)
  ["2026-06-27", "2026-07-20"], // Term 2 break (winter)
  ["2026-09-24", "2026-10-05"], // Term 3 break (spring)
  ["2026-12-12", "2027-01-12"], // Term 4 break (summer)
  // 2027 breaks
  ["2027-03-20", "2027-04-05"], // Term 1 break (autumn)
  ["2027-06-26", "2027-07-19"], // Term 2 break (winter)
  ["2027-09-23", "2027-10-04"], // Term 3 break (spring)
  ["2027-12-11", "2028-01-11"], // year-end (summer)
];

// one-day school closures that also get holiday times
export const SPECIAL_SCHOOL_HOLIDAYS = new Set(["2026-06-15", "2027-04-26"]);

export const PUBLIC_HOLIDAYS = new Set([
  "2026-01-01", "2026-03-21", "2026-04-03", "2026-04-06", "2026-04-27", "2026-05-01",
  "2026-06-16", "2026-08-09", "2026-08-10", "2026-09-24", "2026-12-16", "2026-12-25", "2026-12-26",
  "2027-01-01", "2027-03-21", "2027-03-22", "2027-03-26", "2027-03-29", "2027-04-27", "2027-05-01",
  "2027-06-16", "2027-08-09", "2027-08-10", "2027-09-24", "2027-12-16", "2027-12-25", "2027-12-26",
]);

export function parkOpenStatus(now = new Date(), custom = null) {
  const parts = new Intl.DateTimeFormat("en-ZA", {
    timeZone: "Africa/Johannesburg",
    weekday: "long",
    year: "numeric",
    day: "numeric",
    month: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  }).formatToParts(now);
  const get = (t) => parts.find((x) => x.type === t)?.value || "";
  const weekday = get("weekday");
  const hour = Number(get("hour")) || 0;
  const minute = Number(get("minute")) || 0;
  const month = Number(get("month")) || 0;
  const day = Number(get("day")) || 0;
  const year = get("year");
  const todayIndex = DAY_NAMES.indexOf(weekday);
  // staff set the opening times in the admin portal — "09h00" or "09:00"
  const parseH = (s, fallback) => {
    const m = /^(\d{1,2})[h:](\d{2})$/.exec((s || "").trim());
    return m ? Number(m[1]) + Number(m[2]) / 60 : fallback;
  };
  const weekdayOpen = parseH(custom?.weekday_open, 11);
  const weekdayClose = parseH(custom?.weekday_close, 18);
  const weekendOpen = parseH(custom?.weekend_open, 9);
  const weekendClose = parseH(custom?.weekend_close, 18);
  const fmt = (h) => `${String(Math.floor(h)).padStart(2, "0")}h${String(Math.round((h % 1) * 60)).padStart(2, "0")}`;
  const iso = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  const inRange = ([a, b]) => iso >= a && iso <= b;
  const isSchoolHoliday = SCHOOL_HOLIDAYS.some(inRange) || SPECIAL_SCHOOL_HOLIDAYS.has(iso);
  const isPublicHoliday = PUBLIC_HOLIDAYS.has(iso) || (month === 12 && day === 25);

  if (month === 12 && day === 25) {
    return { open: false, label: "Closed today · Christmas Day", todayIndex, closes: null, opens: null, isSchoolHoliday, isPublicHoliday, reason: "Christmas Day" };
  }
  // Weekends, public holidays and school holidays run on the weekend times
  const holidayHours = isWeekendSafe(weekday) || isSchoolHoliday || isPublicHoliday;
  const opens = holidayHours ? weekendOpen : weekdayOpen;
  const closes = holidayHours ? weekendClose : weekdayClose;
  const mins = hour * 60 + minute;
  if (mins >= opens * 60 && mins < closes * 60) {
    return { open: true, label: `Open now · closes ${fmt(closes)}`, todayIndex, closes, opens, opensToday: false, isSchoolHoliday, isPublicHoliday, reason: isSchoolHoliday ? "School holidays" : isPublicHoliday ? "Public holiday" : null };
  }
  if (mins < opens * 60) {
    const note = isSchoolHoliday ? " · school holidays" : isPublicHoliday ? " · public holiday" : "";
    return { open: false, label: `Closed · opens ${fmt(opens)} today${note}`, todayIndex, closes, opens, opensToday: true, isSchoolHoliday, isPublicHoliday, reason: isSchoolHoliday ? "School holidays" : isPublicHoliday ? "Public holiday" : null };
  }
  const tomorrowWeekend = [0, 6].includes((todayIndex + 1) % 7);
  const [ty, tm, td] = iso.split("-").map(Number);
  const tomorrowIso = new Date(Date.UTC(ty, tm - 1, td + 1)).toISOString().slice(0, 10);
  const tomorrowHoliday = tomorrowWeekend || SCHOOL_HOLIDAYS.some(([a, b]) => tomorrowIso >= a && tomorrowIso <= b) || SPECIAL_SCHOOL_HOLIDAYS.has(tomorrowIso) || PUBLIC_HOLIDAYS.has(tomorrowIso);
  return { open: false, label: `Closed · opens ${fmt(tomorrowHoliday ? weekendOpen : weekdayOpen)} tomorrow`, todayIndex, closes: null, opens: tomorrowHoliday ? weekendOpen : weekdayOpen, opensToday: false, isSchoolHoliday, isPublicHoliday, reason: null };
}

function isWeekendSafe(weekday) {
  return weekday === "Saturday" || weekday === "Sunday";
}
